import type { FeatureRestriction } from '@/lib/feature-permissions';
import { normalizeUserLevel } from '@/lib/feature-permissions';

interface RecommendationAccessOptions {
  level: unknown;
  isLoggedIn: boolean;
  notificationDate?: string | null;
  now?: Date;
}

export function isTPlusOneRecommendation(notificationDate: string | null | undefined, now = new Date()): boolean {
  if (!notificationDate || !/^\d{4}-\d{2}-\d{2}$/.test(notificationDate)) return false;

  const notificationDay = Date.parse(`${notificationDate}T00:00:00Z`);
  if (!Number.isFinite(notificationDay) || new Date(notificationDay).toISOString().slice(0, 10) !== notificationDate) return false;

  const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  return notificationDay === today - 24 * 60 * 60 * 1000;
}

export function getRecommendationAccessRestriction({ level, isLoggedIn, notificationDate, now }: RecommendationAccessOptions): FeatureRestriction | null {
  const normalizedLevel = normalizeUserLevel(level);

  if (!isLoggedIn || normalizedLevel === 'L0') return 'login';
  if (normalizedLevel === 'L2' || normalizedLevel === 'L3') return null;

  return isTPlusOneRecommendation(notificationDate, now) ? null : 'upgrade';
}
